import React from 'react';
import { motion } from 'framer-motion';
import { format, parseISO, isValid } from 'date-fns';
import './TicketCard.css';

const TicketCard = ({
  ticket,
  showResult = false,
  isLive = false,
  index = 0,
  isUpdating = false
}) => {
  const {
    homeTeam,
    awayTeam,
    predictedScore,
    actualScore,
    matchTime,
    date,
    prediction,
    coefficient,
    result, // 'win' | 'loss' | 'pending'
    livescoreUrl,
    status // 'upcoming' | 'live' | 'finished'
  } = ticket;

  // Format date to be short (e.g., "18 Feb") and remove year
  const getShortDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const d = parseISO(dateStr);
      if (isValid(d)) {
        return format(d, 'dd/MM');
      }
      // Fallback if not ISO
      const d2 = new Date(dateStr);
      if (isValid(d2)) {
        return format(d2, 'dd/MM');
      }
      return dateStr;
    } catch (e) {
      return dateStr;
    }
  };

  const resultClass = result || '';
  const isLiveMatch = isLive && status === 'live';

  return (
    <motion.div
      className={`tc-row ${resultClass} ${isLiveMatch ? 'tc-live' : ''} ${isUpdating ? 'tc-updating' : ''}`}
      initial={{ opacity: 0, x: -12 }}
      animate={{
        opacity: 1,
        x: 0,
        scale: isUpdating ? [1, 1.01, 1] : 1
      }}
      transition={{
        delay: index * 0.04,
        duration: 0.25,
        ease: [0.25, 0.46, 0.45, 0.94]
      }}
    >
      {/* Result indicator bar */}
      {result && <div className={`tc-indicator ${result}`} />}

      {/* Live badge */}
      {isLiveMatch && (
        <div className="tc-live-badge">
          <span className="tc-live-dot" />
          <span>LIVE</span>
        </div>
      )}

      {/* CLUBS column */}
      <div className="tc-col tc-clubs">
        <span className="tc-team tc-home">{homeTeam}</span>
        <span className="tc-vs">—</span>
        <span className="tc-team tc-away">{awayTeam}</span>
      </div>

      {/* PREDICTION column */}
      <div className="tc-col tc-prediction">
        {prediction && (
          <span className="tc-pred-badge">{prediction}</span>
        )}
        {predictedScore && (
          <span className="tc-score-badge">{predictedScore}</span>
        )}
        {showResult && actualScore && (
          <span className={`tc-result-badge ${result}`}>{actualScore}</span>
        )}
      </div>

      {/* RIGHT section (Coef + Date) */}
      <div className="tc-right">
        {/* COEFFICIENT column */}
        <div className="tc-col tc-coef">
          <span className="tc-coef-val">{coefficient}</span>
        </div>

        {/* DATE column */}
        <div className="tc-col tc-date">
          {matchTime && <span className="tc-time">{matchTime}</span>}
          {date && <span className="tc-date-text">{getShortDate(date)}</span>}
        </div>
      </div>

      {/* ACTIONS column (optional) */}
      {livescoreUrl && (
        <div className="tc-col tc-actions">
          <a
            href={livescoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="tc-action-btn"
            onClick={(e) => e.stopPropagation()}
            title="ლაივის ნახვა"
          >
            📊
          </a>
        </div>
      )}
    </motion.div>
  );
};

export default TicketCard;
